import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "./input-group.css"

export class InputGroup extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    className: PropTypes.string,
    style: PropTypes.object,
    append: PropTypes.string,
    prepend: PropTypes.string,
    size: PropTypes.oneOf(["sm", "md", "lg", "xl"])
  }

  render() {
    const { children, append, prepend, style } = this.props
    const className = classNames("ck-input-group", this.props.className, {
      [`ck-input-group--${this.props.size}`]: this.props.size
    })
    return (
      <div className={className} style={style}>
        {prepend ? (
          <div className="ck-input-group-prepend">
            <span className="ck-input-group-text">{prepend}</span>
          </div>
        ) : null}
        {children}
        {append ? (
          <div className="ck-input-group-append">
            <span className="ck-input-group-text">{append}</span>
          </div>
        ) : null}
      </div>
    )
  }
}
